import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const alertTypes = [
  { value: 'W', label: StringConstantsMixin.strings.ALERTS.TYPES.WARNING },
  { value: 'I', label: StringConstantsMixin.strings.ALERTS.TYPES.INFORMATIONAL },
  { value: 'C', label: StringConstantsMixin.strings.ALERTS.TYPES.CLOSURE }
];

const defaultAlertType = alertTypes[0];

const alertTypeLabel = alertType => {
  const type = alertTypes.find(type => type.value === alertType);
  return type ? type.label : "";
}

export { alertTypes, defaultAlertType, alertTypeLabel };
